import { useEffect, useRef } from 'react';
import { useReadersStore } from '@/store/readers.store';
import { useRewardsStore } from '@/store/rewards.store';
import { rewardsService } from '@/services/rewards.service';

/**
 * Fetches egg tiers, active eggs, collection, and summary on mount.
 * Requires a selected reader. Returns loading state.
 */
export function useRewardsData() {
  const selectedReader = useReadersStore((s) => s.selectedReader());
  const setEggTiers = useRewardsStore((s) => s.setEggTiers);
  const setActiveEggs = useRewardsStore((s) => s.setActiveEggs);
  const setCollection = useRewardsStore((s) => s.setCollection);
  const setSummary = useRewardsStore((s) => s.setSummary);
  const eggTiers = useRewardsStore((s) => s.eggTiers);
  const loading = useRef(false);

  useEffect(() => {
    if (!selectedReader || loading.current) return;
    loading.current = true;

    const readerId = selectedReader.id;

    Promise.all([
      eggTiers.length === 0 ? rewardsService.getEggTiers() : Promise.resolve(null),
      rewardsService.getActiveEggs(readerId),
      rewardsService.getCollection(readerId),
      rewardsService.getSummary(readerId),
    ])
      .then(([tiers, eggs, collection, summary]) => {
        if (tiers) setEggTiers(tiers);
        setActiveEggs(eggs);
        setCollection(collection);
        setSummary(summary);
      })
      .catch((err) => {
        console.error('[useRewardsData] Failed to load rewards data:', err);
      })
      .finally(() => {
        loading.current = false;
      });
  }, [selectedReader?.id]);
}
